import React from "react";

const LoginBox = (props) => {
  const { className, children } = props;
  return <div className={`login-box ${className}`}>{children}</div>;
};

export default LoginBox;
